import { useEffect, useState } from "react";
import api from "@/lib/api";

// OAuth-authenticated connectors from the registry (native + YAML OAuth), fetched once per session.
let cache = null;
const EMPTY = { keys: [], nativeKeys: [] };

function load() {
    if (!cache) {
        cache = api.get("/oauth/providers")
            .then((r) => {
                const list = r.data?.providers || [];
                return { keys: list.map((p) => p.key), nativeKeys: list.filter((p) => p.flow === "native").map((p) => p.key) };
            })
            .catch(() => { cache = null; return EMPTY; });
    }
    return cache;
}

export function useOAuthProviders() {
    const [state, setState] = useState(EMPTY);
    useEffect(() => {
        let alive = true;
        load().then((v) => { if (alive) setState(v); });
        return () => { alive = false; };
    }, []);
    return state;
}
